"use client";
import { useStore } from "@core/store";
import { useAuthStore } from "@core/store/storeAuth";
import { IUser } from "@core/types/requests/welcome";
import { fetcherAlegriia } from "@utils/requests";
import { AxiosError } from "axios";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useMemo } from "react";
import useSWR from "swr";
import { useShallow } from "zustand/react/shallow";
import { useIsApp } from "../useIsApp";

export const useUser = () => {
  const router = useRouter();
  const pathname = usePathname();
  const isVerifyEmailPage = pathname === "/verify-email";
  const isApp = useIsApp();
  const { token } = useAuthStore(
    useShallow((state) => ({
      token: state.token,
    })),
  );

  const { unsubscribeTopics } = useStore(
    useShallow((state) => ({
      unsubscribeTopics: state.unsubscribeTopics,
    })),
  );

  const { data, error, mutate, isLoading } = useSWR<IUser>(
    token && { url: "/welcome", auth: token },
    fetcherAlegriia,
  );

  useEffect(() => {
    if (
      !isLoading &&
      (error as AxiosError)?.response?.status === 401 &&
      unsubscribeTopics
    ) {
      // router.replace("/");
      // cleanToken();
      return;
    }
    if (
      !isVerifyEmailPage &&
      ((!!data && !data?.verified && !isLoading && !!token) ||
        error?.response?.data?.error === "Not verified Email")
    )
      return router.replace("/verify-email?i=1");
    if (isVerifyEmailPage && !!data?.verified) return router.replace("/");
  }, [
    router,
    token,
    isLoading,
    error,
    unsubscribeTopics,
    data,
    isVerifyEmailPage,
    isApp,
  ]);

  return useMemo(
    () => ({
      token,
      ...data,
      email: data?.email ?? error?.response?.data?.email,
      mutate,
      isLoading,
    }),
    [token, data, error, mutate, isLoading],
  );
};
